export const BUNDLED_EXPERIENCE_NAME_COLUMN_MIN_WIDTH = 110;

export const BUNDLED_EXPERIENCE_COLUMN_WIDTHS = {
  validity: 90,
  blackouts: 120,
  currency: 100,
  childAge: 90,
  action: 120,
} as const;
